import { SCALE_LABELS } from '../../constants/defaults';
import { formatPrice, getPriceTier } from '../../utils/pricing';
import './WizardStep.css';

export default function StepReview({ formData, priceData, pricingEnabled }) {
  const { brandCore, visuals, scales } = formData;

  const formatFontStyle = (style) => {
    return style.charAt(0).toUpperCase() + style.slice(1);
  };

  const formatColorMode = (mode) => {
    return mode.charAt(0).toUpperCase() + mode.slice(1);
  };

  const tier = priceData ? getPriceTier(priceData.total) : null;

  return (
    <div className="wizard-step wizard-step--review">
      <div className="wizard-step__header">
        <h2 className="wizard-step__title">Review your brief</h2>
        <p className="wizard-step__description">
          Take a moment to review your selections before creating your brief card.
        </p>
      </div>

      <div className="wizard-step__content">
        <div className="review-sections">
          <section className="review-section">
            <h3 className="review-section__title">Brand Core</h3>
            <div className="review-section__content">
              <div className="review-item">
                <span className="review-item__label">Name</span>
                <span className="review-item__value">{brandCore.name || '—'}</span>
              </div>
              <div className="review-item">
                <span className="review-item__label">Mission</span>
                <span className="review-item__value">{brandCore.mission || '—'}</span>
              </div>
              <div className="review-item">
                <span className="review-item__label">Vibe Keywords</span>
                <span className="review-item__value review-item__value--keywords">
                  {brandCore.vibeKeywords.filter(k => k).length > 0 
                    ? brandCore.vibeKeywords.filter(k => k).map((keyword, i) => (
                        <span key={i} className="review-keyword">{keyword}</span>
                      ))
                    : <span className="review-item__empty">Not specified</span>
                  }
                </span>
              </div>
            </div>
          </section>

          <section className="review-section">
            <h3 className="review-section__title">Visuals</h3>
            <div className="review-section__content">
              <div className="review-item">
                <span className="review-item__label">Accent Color</span>
                <span className="review-item__value review-item__value--color">
                  <span 
                    className="review-color-swatch"
                    style={{ backgroundColor: visuals.colorSeed }}
                  />
                  {visuals.colorSeed.toUpperCase()}
                </span>
              </div>
              <div className="review-item">
                <span className="review-item__label">Color Mode</span>
                <span className="review-item__value">{formatColorMode(visuals.colorMode)}</span>
              </div>
              <div className="review-item">
                <span className="review-item__label">Font Style</span>
                <span className="review-item__value">{formatFontStyle(visuals.fontStyle)}</span>
              </div>
            </div>
          </section>

          <section className="review-section">
            <h3 className="review-section__title">Scales</h3>
            <div className="review-section__content">
              <div className="review-item">
                <span className="review-item__label">
                  {SCALE_LABELS.minimalistDense.low} ↔ {SCALE_LABELS.minimalistDense.high}
                </span>
                <span className="review-item__value">{scales.minimalistDense}%</span>
              </div>
              <div className="review-item">
                <span className="review-item__label">
                  {SCALE_LABELS.playfulSerious.low} ↔ {SCALE_LABELS.playfulSerious.high}
                </span>
                <span className="review-item__value">{scales.playfulSerious}%</span>
              </div>
              <div className="review-item">
                <span className="review-item__label">
                  {SCALE_LABELS.safeExperimental.low} ↔ {SCALE_LABELS.safeExperimental.high}
                </span>
                <span className="review-item__value">{scales.safeExperimental}%</span>
              </div>
            </div>
          </section>

          {pricingEnabled && priceData && (
            <section className="review-section review-section--pricing">
              <h3 className="review-section__title">Estimated Investment</h3>
              <div className="review-section__content">
                <div className="review-pricing">
                  <div className="review-pricing__total">
                    <span className="review-pricing__amount">
                      {formatPrice(priceData.total)}
                    </span>
                    <span 
                      className="review-pricing__tier"
                      style={{ backgroundColor: tier?.color }}
                    >
                      {tier?.label}
                    </span>
                  </div>
                  {priceData.items.length > 0 && (
                    <div className="review-pricing__factors">
                      <span className="review-pricing__factors-label">Price factors:</span>
                      <span className="review-pricing__factors-list">
                        Base ({formatPrice(priceData.base)})
                        {priceData.items.map((item, i) => (
                          <span key={i}> + {item.label}</span>
                        ))}
                        {priceData.multipliers.map((mult, i) => (
                          <span key={i}> × {mult.label}</span>
                        ))}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    </div>
  );
}
